import { monthInsightSchema } from '@klopotun/contracts';
import { apiRequest } from '../../../../shared/api/index.js';
import type { MonthInsight } from '../../model/month-insight.js';
import type { MonthInsightDto } from '../dto/month-insight.dto.js';
import { toMonthInsight } from '../mappers/month-insight.mapper.js';

const fetchMonthInsight = async (signal: AbortSignal): Promise<MonthInsightDto> =>
  monthInsightSchema.parse(await apiRequest<unknown>('/summary/insight', { signal }));

export const getMonthInsight = async (signal: AbortSignal): Promise<MonthInsight> =>
  toMonthInsight(await fetchMonthInsight(signal));
